import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";

export default function EmployeeLegalOrdersPage() {
    const navigate = useNavigate();

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        loadOrders();
    }, []);

    const loadOrders = async () => {
        try {
            const { data } = await api.get("/orders"); // можно сделать /orders/legal если есть
            setOrders(Array.isArray(data) ? data : []);
        } catch (err) {
            setError("Failed to load legal orders");
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = (orderId) => {
        navigate(`/employee/orders/${orderId}`);
    };

    const handleRefund = async (paymentId) => {
        if (!window.confirm("Refund this payment?")) return;

        try {
            await api.post("/payments/refund", { paymentId });
            alert("Refund successful");
            loadOrders();
        } catch {
            alert("Refund failed");
        }
    };

    if (loading) return <p className="text-center">Loading...</p>;
    if (error) return <p className="text-red-500 text-center">{error}</p>;

    return (
        <div className="max-w-5xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-2xl font-bold mb-4">
                📊 Legal Entity Orders (Employee)
            </h2>

            {orders.length === 0 ? (
                <p className="text-gray-500">No orders found.</p>
            ) : (
                orders.map((o) => (
                    <div
                        key={o.id}
                        className="border p-4 mb-3 rounded hover:shadow"
                    >
                        <div className="flex justify-between items-center">
                            <div>
                                <p>
                                    <b>Order:</b>{" "}
                                    {o.orderNumber || o.id}
                                </p>
                                <p>
                                    <b>Amount:</b>{" "}
                                    {o.totalAmount} {o.currency}
                                </p>
                                <p>
                                    <b>Payment:</b>{" "}
                                    {o.paymentStatus || "Pending"}
                                </p>
                                <p>
                                    <b>Shipment:</b>{" "}
                                    {o.shipment?.status || "Created"}
                                </p>
                            </div>

                            <div className="flex gap-2">
                                <button
                                    onClick={() => handleOpen(o.id)}
                                    className="bg-blue-600 text-white px-3 py-1 rounded"
                                >
                                    Open
                                </button>

                                {o.paymentStatus === "Completed" && (
                                    <button
                                        onClick={() =>
                                            handleRefund(o.paymentId)
                                        }
                                        className="bg-red-600 text-white px-3 py-1 rounded"
                                    >
                                        Refund
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}